exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes sk-fade-in {\n  0% {\n      opacity: 0;\n  }\n  50% {\n      opacity: 0;\n  }\n  100% {\n      opacity: 1;\n  }\n}\n\n@keyframes sk-fade-in {\n  0% {\n      opacity: 0;\n  }\n  50% {\n      opacity: 0;\n  }\n  100% {\n      opacity: 1;\n  }\n}\n\n.sk-fade-in {\n  -webkit-animation: sk-fade-in 2s;\n  animation: sk-fade-in 2s;\n}\n\n.sk-fade-in-half-second {\n  -webkit-animation: sk-fade-in 1s;\n  animation: sk-fade-in 1s;\n}\n\n.sk-fade-in-quarter-second {\n  -webkit-animation: sk-fade-in 0.5s;\n  animation: sk-fade-in 0.5s;\n}\n", ""]);

// exports
